import { render, staticRenderFns } from "./AddAdministratorModal.vue?vue&type=template&id=e54defb4&"
import script from "./AddAdministratorModal.vue?vue&type=script&lang=js&"
export * from "./AddAdministratorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports